package pro.jayeshseth.animations.core.ui.theme

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.toArgb

val Purple80 = Color(0xFFD0BCFF)
val PurpleGrey80 = Color(0xFFCCC2DC)
val Pink80 = Color(0xFFEFB8C8)

val Purple40 = Color(0xFF6650a4)
val PurpleGrey40 = Color(0xFF625b71)
val Pink40 = Color(0xFF7D5260)

val Sky500 = Color(0xFF03A9F4)
val Yellow200 = Color(0xFFFFEB3B)

val Red400 = Color(0xFFEF5350)
val Pink400 = Color(0xFFEC407A)
val Purple400 = Color(0xFFAB47BC)
val DeepPurple400 = Color(0xFF7E57C2)
val Indigo400 = Color(0xFF5C6BC0)
val Blue400 = Color(0xFF42A5F5)
val LightBlue400 = Color(0xFF29B6F6)
val Cyan = Color(0xFF00FFFF)
val Teal400 = Color(0xFF26A69A)
val Green400 = Color(0xFF66BB6A)
val LightGreen400 = Color(0xFF9CCC65)
val Lime400 = Color(0xFFD4E157)
val Yellow400 = Color(0xFFFFEE58)
val Orange400 = Color(0xFFFFA726)
val DeepOrange400 = Color(0xFFFF7043)
val BlueGrey300 = Color(0xFF90A4AE)